import { useDisclosure } from "@chakra-ui/hooks";
import Card from "components/card/custom";
import { useCallback, useContext, useEffect, useState } from "react";
import { BsPlusCircle } from "react-icons/bs";
import { MdHighlightOff } from "react-icons/md";
import { Modal, ModalBody, ModalOverlay , ModalHeader , ModalFooter } from "@chakra-ui/modal";
import { getAllOrganizationsSecond } from "api/graphQL_organizations";
import { getClientsSecond, getClientTreasuryTotal } from "api/graphQL_clients";
import { Select as AntSelect } from "antd";
import DivLoader from "components/divloader/DivLoader";
import { FiUploadCloud, FiXCircle } from "react-icons/fi";
import toast from "react-hot-toast";
import { useDropzone } from "react-dropzone";
import { ClientContext } from "ClientProvider";
import { createRegularBatchPayout } from "api/graphQL_crypto"
import Batch from "../../../../../assets/csv/RegularPayoutBatch.csv";
import TokenizeBatch from "../../../../../assets/csv/TokenizePayoutBatch.csv";
import Papa from "papaparse";
import { getAllGatewaysByClient , getGatewayBalance} from "api/graphQL_gateways";
import { getCurrencySymbol, currencyCodes } from "utils/currencyList"; 
import axios, { AxiosError, AxiosPromise, AxiosRequestConfig } from "axios";

interface DisplayData {
  gateway: any;
  currency: any;
  total_amount: {
    totalAmount: any;
    totalPercentageFee: any;
    totalFixedFee: any;
    totalFees: any;
  } | null;
  gateway_id: any;
  client_id: any;
  gateway_details: any;
  gateway_balance: any;
  client_treasury: any;
}


interface iCreateBatchForm {
    org_id: string;
    client_id: string;
    batch_file : any;
    gateway:any;
    batch_type:any;
}

export type AllGatewayObj = {
  name: string;
  id: string;
};

export type SourceCurrencyObj = {
  name: string;
  id: string;
};

// const FileDropzone = ({ label, onFileSelect , onRemoveFile}: { label: string; onFileSelect: (file: string | null) => void , onRemoveFile:any} ) => {
//     const [fileName, setFileName] = useState("");
//     const onDrop = useCallback((acceptedFiles: File[]) => {
//         const file = acceptedFiles[0];
//         if (file) {
//             const allowedTypes = ["text/csv", "application/vnd.ms-excel"];
//             if (allowedTypes.includes(file.type)) {
//                 setFileName(file.name);
//                 const reader = new FileReader();
//                 reader.readAsDataURL(file);
//                 reader.onloadend = () => {
//                     onFileSelect(reader.result as string);
//                 };
//             } else {
//                 toast.error("Only CSV files are allowed.");
//                 setFileName("");
//                 onFileSelect(""); 
//             }
//         }
//     }, [onFileSelect]);
//     const removeFile = () => {
//         onRemoveFile(true);
//         setFileName("");
//         onFileSelect("");
//     };
//     const { getRootProps, getInputProps } = useDropzone({
//         onDrop,
//     });
//     return (
//         <div
//             {...getRootProps()}
//             className="flex flex-col items-center justify-center p-6 border-2 border-dashed border-gray-400/30 
//             rounded-xl cursor-pointer bg-white/70 dark:bg-gray-800/70 backdrop-blur-lg hover:border-blue-500 
//             hover:shadow-xl transition-all duration-300 w-full h-36 shadow-lg dark:shadow-gray-900/40 relative"
//         >
//             <input {...getInputProps()} />
//             {fileName  ? (
//                 <div className="relative flex items-center gap-2">
//                     <FiUploadCloud className="text-green-600 text-xl" />
//                     <span className="text-sm dark:text-white">{fileName}</span>
//                     <button
//                     onClick={(e) => {
//                         e.stopPropagation();
//                         removeFile();
//                     }}
//                     className="ml-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 transition-all"
//                     >
//                     <FiXCircle className="text-sm" />
//                     </button>
//                 </div>
//             ) : (
//                 <div className="flex flex-col items-center">
//                     <FiUploadCloud className="text-blue-500 text-4xl mb-3 transition-transform duration-300 hover:scale-110" />
//                     <p className="text-gray-600 text-sm dark:text-gray-300 font-medium">{label}</p>
//                 </div>
//             )}
//         </div>
//     );
// };

const FileDropzone = ({ label, onFileSelect , onRemoveFile , sampleBatchFile , resetKey}: { label: string; onFileSelect: (file: string | null) => void , onRemoveFile:any , sampleBatchFile : any , resetKey?: any} ) => {
    const [fileName, setFileName] = useState("");
    const onDrop = useCallback((acceptedFiles: File[]) => {
        const file = acceptedFiles[0];
        if (file) {
            const allowedTypes = ["text/csv", "application/vnd.ms-excel"];
            if (allowedTypes.includes(file.type)) {
                setFileName(file.name);
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onloadend = () => {
                    onFileSelect(reader.result as string);
                };
            } else {
                toast.error("Only CSV files are allowed.");
                setFileName("");
                onFileSelect(""); 
            }
        }
    }, [onFileSelect]);
    useEffect(() => {
        if (resetKey) {
        onRemoveFile(true);
        setFileName("");
        onFileSelect(""); 
        }
    }, [resetKey]);
    const removeFile = () => {
        onRemoveFile(true);
        setFileName("");
        onFileSelect("");
    };
    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        disabled: !sampleBatchFile,
    });
    return (
        <div
            {...getRootProps()}
            className={`flex flex-col items-center justify-center p-6 border-2 border-dashed rounded-xl cursor-pointer w-full h-36 shadow-lg relative transition-all duration-300
            ${
            sampleBatchFile
                ? "border-gray-400/30 bg-white/70 dark:bg-gray-800/70 hover:border-blue-500 hover:shadow-xl"
                : "border-gray-300 bg-gray-100 dark:bg-gray-700 opacity-60 cursor-not-allowed"
            }`}
        >
            <input {...getInputProps()} />
            {fileName  ? (
                <div className="relative flex items-center gap-2">
                    <FiUploadCloud className="text-green-600 text-xl" />
                    <span className="text-sm dark:text-white">{fileName}</span>
                    <button
                    onClick={(e) => {
                        e.stopPropagation();
                        removeFile();
                    }}
                    className="ml-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 transition-all"
                    >
                    <FiXCircle className="text-sm" />
                    </button>
                </div>
            ) : (
                <div className="flex flex-col items-center">
                    {/* <FiUploadCloud className="text-blue-500 text-4xl mb-3 transition-transform duration-300 hover:scale-110" /> */}
                    <FiUploadCloud
                        className={`text-4xl mb-3 transition-transform duration-300 ${
                        sampleBatchFile ? "text-blue-500 hover:scale-110" : "text-gray-400"
                        }`}
                    />
                    <p className="text-gray-600 text-sm dark:text-gray-300 font-medium">{label}</p>
                </div>
            )}
        </div>
    );
};

const AddBatchFile = ({
  fetchPayouts
}: {
  fetchPayouts: () => void;
}) => {
    const rootForm = {
        org_id: "",
        client_id: "",
        batch_file:"",
        gateway:"",
        batch_type:"regular"
    };
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [isCloseModal, setIsCloseModal] =  useState<boolean>(false);
    const [page, setPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(500);
    const [searchTexts, setSearchTexts] = useState<string>("");
    const [organizations, setOrganizations] = useState<any[]>([]);
    const [allOrg,setAllOrg] = useState<any[]>([]);
    const [clients, setClients] = useState<any[]>([]);
    const [formValues, setFormValues] = useState<iCreateBatchForm>(rootForm);
    const [formValuesErr, setFormValuesErr] =useState<iCreateBatchForm>(rootForm);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [batchFile, setBatchFile] = useState<string | null>(null);
    const [removeFile,setRemoveFile] = useState(false)
    const { singleRoleData } = useContext(ClientContext);
    const [allGateways, setAllGateways] = useState<AllGatewayObj[]>([]);
    const [allSourceCurrency, setAllSourceCurrency] = useState<SourceCurrencyObj[]>([]);
    const [addDisabled,isAddDisabled] = useState(true)
    const [sourceCurrency,setSourceCurrency] = useState("")
    const [selectedGateway, setSelectedGateway] = useState("")
    const [displayData,setDisplayData] = useState<DisplayData  | null>(null);
    const [isBalanceLoading,setIsBalanceLoading] = useState(false)
    const [lowBalanceError,setLowBalanceError] = useState("")
    const [sampleBatchFile, setSampleBatchFile] = useState<string | null>(Batch);
    const [smapleBatchName, setSampleBatchName] = useState<string>("Regular Batch File");
    const [resetKey, setResetKey] = useState(0);
    const fetchClients = (org_id : any) => {
        if(org_id == "" || org_id == null || org_id == undefined) {
            setClients([]);
        } else {
            const selectedOrgName = allOrg.find(org => org.id === org_id)?.name || '';
            const params = { page: page, per_page: pageSize, searchTexts: selectedOrgName };
            getClientsSecond(params)
            .then((data) => {
                setClients(
                data?.[0]?.map((ele: any) => {
                    return {
                    name: ele.name,
                    id: ele.client_id,
                    };
                })
                );
            });
        }
    };
    
    const fetchOrganizations = () => {
        getAllOrganizationsSecond(
            page,
            pageSize,
            searchTexts,
        )
        .then((data) => {
            setOrganizations(
              data?.[0]?.map((ele: any) => {
                return {
                  name: ele.name,
                  id: ele.id,
                };
              })
            );
            setAllOrg(data?.[0]?.map((ele: any) => {
                return {
                  name: ele.name,
                  id: ele.id,
                };
              }));
        });
    };

    const fetchGateways = (client_id: any) => {
        getAllGatewaysByClient(client_id)
        .then((data) => {
            const filtered = (data ?? []).filter((gateway : any) =>
                gateway?.payment_method?.filterPaymentMethod?.some(
                (method : any) => method.name === "payout" && method.is_Active === true
                )
            );
            const transformed = filtered.map((item:any) => ({
                ...item,
                id: item.gateway_id
            }));
            setAllGateways(transformed);
        })
        .catch((err) => {
        console.error(err);
        })
        .finally(() => {
        });
    };

    const handleClose = () => {
        setFormValues(rootForm);
        setFormValuesErr(rootForm);
        setBatchFile("")
        setIsCloseModal(true)
        setClients([]);
        setAllGateways([])
        setAllSourceCurrency([])
        setSourceCurrency("")
        setDisplayData(null)
        isAddDisabled(true)
        setSampleBatchFile(Batch);
        setSampleBatchName("Regular Batch File");
        setTimeout(() => {
          setIsCloseModal(false)
          onClose();
        }, 300);
    };

    useEffect(() => {
        if (typeof batchFile === "string" && batchFile.trim() !== "") {
            setRemoveFile(false);
            setFormValues((preVal: any) => ({
                ...preVal,
                batch_file: batchFile
            }));
            setFormValuesErr((preVal: any) => ({
                ...preVal,
                batch_file: ""
            }));
            fetchBalance(batchFile);
        }
    }, [batchFile]);

    useEffect(() => {
        if(removeFile) {
            setFormValues((preVal: any) => {
                return { ...preVal, batch_file: ""};
            });
            setFormValuesErr((preVal: any) => {
                return { ...preVal, batch_file: "The field is required" };
            });
            setDisplayData(null)
        }
    },[removeFile])

    function validateData() {
        let verifier: iCreateBatchForm;
        if (!formValues?.org_id) {
          verifier = { ...verifier, org_id: "The field is required" };
        }
        if (!formValues?.client_id) {
            verifier = { ...verifier, client_id: "The field is required" };
        }
        if (!formValues?.gateway) {
            verifier = { ...verifier, gateway: "The field is required" };
        }
        if (!formValues?.batch_file) {
            verifier = { ...verifier, batch_file: "The field is required" };
        }
        if (verifier) {
          setFormValuesErr(verifier);
          return false;
        }
        return true;
    }

    const validateCSV = (csvDataUri: string) => {
        let REQUIRED_HEADERS: string[] = [];

        if (formValues.batch_type === "regular") {
            REQUIRED_HEADERS = [
                "sender_first_name", "sender_middle_name", "sender_last_name", "sender_email",
                "sender_phone", "sender_city", "sender_address", "sender_postal_code", "sender_state",
                "sender_country", "sender_birth_date", "sender_bank_id", "sender_account_number",
                "sender_document_type", "sender_document_number", "receiver_first_name", 
                "receiver_middle_name", "receiver_last_name", "receiver_email", "receiver_phone", 
                "receiver_city", "receiver_address", "receiver_postal_code", "receiver_state", 
                "receiver_country", "receiver_birth_date", "receiver_bank_id", "receiver_account_number", 
                "receiver_document_type", "receiver_document_number"
            ];
        } else if (formValues.batch_type === "tokenize") {
            REQUIRED_HEADERS = [
                "sender_customer_id", "sender_payment_method_id", "sender_kyc_id",
                "receiver_customer_id", "receiver_payment_method_id", "receiver_kyc_id",
                "amount", "currency"
            ];
        }

        const base64Data = csvDataUri.replace(/^data:text\/csv;base64,/, '');
        const csvText = atob(base64Data);

        const parsed = Papa.parse<Record<string, string>>(csvText, {
            header: true,
            skipEmptyLines: true
        });

        if (parsed.errors.length > 0) {
            toast.error("CSV parsing failed, please download the sample CSV file to see data structure");
            return false;
        }

        const data = parsed.data;
        // const actualHeaders = Object.keys(data[0] || {});
        const actualHeaders = Object.keys(data[0] || {}).map(h => h.trim()).filter(h => h !== "");
        const missingHeaders = REQUIRED_HEADERS.filter(h => !actualHeaders.includes(h));

        if (missingHeaders.length > 0) {
            const formattedMissing = missingHeaders.map(h => h.replace(/_/g, ' '));
            toast.error(`Missing headers: ${formattedMissing.join(", ")}. Please download sample CSV file to see data structure.`);
            return false;
        }

        const nonEmptyData = data.filter(row =>
            Object.values(row).some(value => value && String(value).trim() !== "")
        );

        for (let i = 0; i < nonEmptyData.length; i++) {
            const row = nonEmptyData[i];
            for (let header of REQUIRED_HEADERS) {
                if (!row[header] || String(row[header]).trim() === "") {
                    const formattedHeader = header.replace(/_/g, ' ');
                    toast.error(`Row ${i + 2}: "${formattedHeader}" is missing. Please download sample CSV file to see data structure.`);
                    return false;
                }
            }
        }


        // for (let i = 0; i < data.length; i++) {
        //     const row = data[i];
        //     for (let header of REQUIRED_HEADERS) {
        //         if (!row[header] || String(row[header]).trim() === "") {
        //             const formattedHeader = header.replace(/_/g, ' ');
        //             toast.error(`Row ${i + 2}: "${formattedHeader}" is missing. Please download sample CSV file to see data structure.`);
        //             return false;
        //         }
        //     }
        // }

        return true;
    };

    //   const REQUIRED_HEADERS = ["sender_first_name","sender_middle_name","sender_last_name","sender_email","sender_phone","sender_city","sender_address","sender_postal_code","sender_state","sender_country","sender_birth_date","sender_bank_id","sender_account_number","sender_document_type","sender_document_number","receiver_first_name","receiver_middle_name","receiver_last_name","receiver_email","receiver_phone","receiver_city","receiver_address","receiver_postal_code","receiver_state","receiver_country","receiver_birth_date","receiver_bank_id","receiver_account_number","receiver_document_type","receiver_document_number"];

    // const validateCSV = (csvDataUri: string) => {

    //     const base64Data = csvDataUri.replace(/^data:text\/csv;base64,/, '');
    //     const csvText = atob(base64Data);
    //     const parsed = Papa.parse<Record<string, string>>(csvText, {
    //         header: true,
    //         skipEmptyLines: true
    //     });

    //     if (parsed.errors.length > 0) {
    //         toast.error("CSV parsing failed , please download sample csv file to see data structure");
    //         return false;
    //     }

    //     const data = parsed.data;

    //     const actualHeaders = Object.keys(data[0] || {});
    //     const missingHeaders = REQUIRED_HEADERS.filter(h => !actualHeaders.includes(h));
    //     if (missingHeaders.length > 0) {
    //         const formattedMissing = missingHeaders.map(h => h.replace(/_/g, ' '));
    //         toast.error(`Missing headers: ${formattedMissing.join(", ")} , please download sample csv file to see data structure`);
    //         return false;
    //     }

    //     for (let i = 0; i < data.length; i++) {
    //         const row = data[i];
    //         for (let header of REQUIRED_HEADERS) {
    //             if (!row[header] || String(row[header]).trim() === "") {
    //                 const formattedHeader = header.replace(/_/g, ' ');
    //                 toast.error(`Row ${i + 2}: "${formattedHeader}" is missing , please download sample csv file to see data structure`);
    //                 return false;
    //             }
    //         }
    //     }

    //     return true;
    // };

    async function handleSubmit(e: any) {
        e.preventDefault();
        let validate = validateData();

        if (validate) {

            const isValid = validateCSV(formValues.batch_file);
            if (isValid) {
                setIsLoading(true);
                const data = {
                    "client_id" : formValues.client_id,
                    "organization_id" : formValues.org_id,
                    "file" : formValues.batch_file,
                    "gateway": formValues.gateway,
                    "settlement_currency" : sourceCurrency,
                    "total_fees" : (displayData?.total_amount?.totalFees ?? "0"),
                    "batch_type" : formValues.batch_type
                }
                createRegularBatchPayout(data)
                .then((data:any) => {
                    if(data.message == 'There are no any payout gateway assigned to client') {
                        toast.error(data.message);    
                        setIsLoading(false);
                    } else {
                        toast.success(data.message);
                        setIsLoading(false);
                        handleClose();
                        fetchPayouts();
                    }
                })
                .catch((err) => {
                })
                .finally(() => {
                });
            }
        }
    }

    const convertAmount = async(amount : any, from_currency : any , to_currency:any) => {

        let final_from_currency = ""

        if(from_currency == "LEU" || from_currency == "RON") {
            final_from_currency = "RON"
        } else if(from_currency == "BOL" || from_currency == "BOB") {
            final_from_currency = "BOB"
        } else if(from_currency == "VES") {
            final_from_currency = "VES"
        }

        let data = '';
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: 'https://api.fastforex.io/convert?api_key=629bf7299e-e7215fb94a-s85scd&from='+final_from_currency+'&to='+to_currency+'&amount='+amount,
            headers: { },
            data : data
        };

        return axios.request(config)
            .then((response) => {
                console.log(response.data);
                return response.data.result[to_currency]
            })
            .catch((error) => {
            console.log(error);
            });
    }

    const readCSV = async(csvDataUri: string , margin_fee :any) => {

        const isValid = await validateCSV(csvDataUri);

        if (!isValid) {
            return false;
        }

        const base64Data = csvDataUri.replace(/^data:text\/csv;base64,/, '');
        const csvText = atob(base64Data);
        const parsed = Papa.parse<Record<string, string>>(csvText, {
            header: true,
            skipEmptyLines: true
        });

        if (parsed.errors.length > 0) {
            console.log("parsed.errors",parsed.errors)
            toast.error("CSV parsing failed, please download sample CSV file to see data structure");
            return false;
        }

        const data = parsed.data;

        const percentageFeeValue = parseFloat(margin_fee?.percentageFee || "0");
        const fixedFeeValue = parseFloat(margin_fee?.fixedFee || "0");

        let totalAmount = 0;
        let totalPercentageFee = 0;
        let totalFixedFee = 0;

        for (const row of data) {
            if(row.amount && row.currency) {
                const converted_amount = await convertAmount(row.amount, row.currency, sourceCurrency);
                const amount = parseFloat(converted_amount || "0");
                const cleanAmount = isNaN(amount) ? 0 : amount;
                const percentageFeePerRow = cleanAmount * (percentageFeeValue / 100);
                const fixedFeePerRow = fixedFeeValue;
                totalAmount += cleanAmount;
                totalPercentageFee += percentageFeePerRow;
                totalFixedFee += fixedFeePerRow;
            }
        }

        const totalFees = totalPercentageFee + totalFixedFee;

        return {
            totalAmount,
            totalPercentageFee,
            totalFixedFee,
            totalFees
        };

    };

    const fetchMarginFee = async(client_id: any, gateway_id: any) => {
        return getAllGatewaysByClient(client_id)
            .then((data) => {
                if (!data || !Array.isArray(data)) {
                    console.error("Invalid data response");
                    return null;
                }
                const gateway = data.find(
                    (gateway: any) => gateway.gateway_id === gateway_id
                );
                if (!gateway) {
                    console.error("Gateway not found for the provided gateway_id");
                    return null;
                }
                const cryptoFees = gateway?.reserved_pricing?.crypto_fees;
                if (!cryptoFees) {
                    console.error("Crypto fees not defined in reserved_pricing");
                    return null;
                }
                if(cryptoFees.currency_code == sourceCurrency) {
                    const percentageFee = cryptoFees.percentage_fee;
                    const fixedFee = cryptoFees.fixed_fee;
                    const currency_code = cryptoFees.currency_code;

                    const authInfo = gateway?.auth_info
                    return { percentageFee, fixedFee , currency_code, authInfo};
                } else {
                    toast.error("Crypto fees not defined for "+sourceCurrency);
                    return null;
                }
            })
            .catch((err) => {
               
            });
    };
    
    // const fetchGatewayBalance = async(gateway:any,currency:any,gateway_details:any) => {
    //     const data =  {
    //         "gateway": gateway,
    //         "currency": currency,
    //         "authInfo" : gateway_details.authInfo
    //     }
    //     return getGatewayBalance(data)
    //     .then((data) => {
    //         return data.balance
    //     })
    //     .catch((err) => {
    //     });
    // }

    const fetchClientTreasury = async(client_id : any) => {
        return getClientTreasuryTotal(client_id,sourceCurrency)
        .then((data) => { 
            return data[0].total_treasury
        })
        .catch((err) => {
        });
    }
    
    const fetchBalance = async (batchFile: any) => {
        setIsBalanceLoading(true)
        isAddDisabled(true)
        const gateway = selectedGateway;
        const currency = sourceCurrency;
        const gateway_details = await fetchMarginFee(formValues.client_id, formValues.gateway);
        if(gateway_details != null ) {
            
            const total_amount = await readCSV(batchFile,gateway_details);

            if(total_amount) {
            // const gateway_balance = await fetchGatewayBalance(gateway,currency,gateway_details)
                const client_treasury = await fetchClientTreasury(formValues.client_id)

                const final_data : DisplayData  = {
                    gateway: gateway,
                    currency: currency,
                    total_amount: total_amount && typeof total_amount === "object" ? total_amount : null,
                    gateway_id: formValues.gateway,
                    client_id: formValues.client_id,
                    gateway_details: gateway_details,
                    gateway_balance : null,
                    client_treasury : client_treasury
                };
                setDisplayData(final_data);
                if (!total_amount) {
                    toast.error("Failed to process CSV data.");
                    setIsBalanceLoading(false)
                    return;
                }
                // if(parseFloat(gateway_balance) > total_amount.totalAmount) {
                    if(parseFloat(client_treasury) > total_amount.totalFees){
                        isAddDisabled(false)
                        setIsBalanceLoading(false)
                        setLowBalanceError("")
                    } else {
                        setIsBalanceLoading(false)
                        isAddDisabled(true)
                        setLowBalanceError("Insuffisant funds to process the batch. Please contact your representative to refill your account")
                    }
                // } else {
                //     isAddDisabled(true)
                // }
            } else {
                setIsBalanceLoading(false)
                setDisplayData(null);
            }
           
        } else {
            setIsBalanceLoading(false)
            setDisplayData(null);
        }
    
    };

    const sampleBatch: Record<string, any> = {
        Regular: Batch,
        Tokenize : TokenizeBatch
    };

    const handleFieldChange = (field: string, value: any) => {
        let batch = ""

        if(value === 'regular') {
            batch = sampleBatch['Regular'] || null;
        } else if(value === "tokenize") {
            batch = sampleBatch["Tokenize"] || null;
        } else {
            batch = ""
        }

        if (batch) {
            setSampleBatchFile(batch);
            setSampleBatchName(`${value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()} Batch File`);
        } else {
            setSampleBatchFile(null);
            setSampleBatchName("");
        }

        setFormValues((prev: any) => ({
            ...prev,
            [field]: value,
        }));
        setFormValuesErr((prev: any) => ({
            ...prev,
            [field]: "",
        }));
        setFormValues((preVal: any) => {
            return { ...preVal, batch_file: ""};
        });
        setDisplayData(null)
        setResetKey(prev => prev + 1);
    }



    return ( 
        <>
            {singleRoleData?.[0]?.payout?.value?.add_payout_batch_file && (
                <div onClick={() => {fetchOrganizations(); onOpen(); }}>
                    <Card extra="w-fit px-5 cursor-pointer">
                        <button className="flex items-center justify-center gap-2 whitespace-nowrap p-5 text-navy-700 outline-none dark:text-gray-200">
                        <BsPlusCircle className="h-5 w-5 text-brand-500" />
                        <span className="text-brand-500"> Batch Payout</span>
                        </button>
                    </Card>
                </div>
            )}
            <Modal isOpen={isOpen} onClose={() => {}}>
                <ModalOverlay className="bg-[#000] !opacity-30" />
                <Card extra={`fixed top-0 right-0 h-full rounded-none max-w-[600px] sm:w-full flex flex-col justify-start !z-[1004] overflow-y-auto scrollbar-hide overflow-auto ${isOpen && !isCloseModal ? "card-enter" : "card-exit" }`}> 
                    <ModalHeader className="py-[20px] mb-[20px] px-[30px] text-2xl font-bold bg-brand-500 text-white">
                        <MdHighlightOff className="absolute right-7 top-6 h-8 w-8 cursor-pointer text-white" onClick={handleClose}/>
                        Batch Payout
                    </ModalHeader>
                    <ModalBody className="p-2">
                        <div className="px-[30px]">
                            <div className="flex gap-5">
                                <div className="w-full">
                                    <label
                                        htmlFor="org_id"
                                        className={`ml-1.5 text-sm font-bold text-gray-900 dark:text-white`}
                                    >
                                        Organization<span className="important">*</span>
                                    </label>
                                    <AntSelect
                                        showSearch={true}
                                        filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                        allowClear
                                        placeholder="Select Organization"
                                        optionFilterProp="children"
                                        className="h-[48px] w-full mt-[5px]"
                                        options={organizations?.map((m: any) => {
                                        return {
                                            ...m,
                                            label: m?.name,
                                            value: m?.id,
                                        };
                                        })}
                                        value={formValues?.org_id || undefined}
                                        onChange={(e: any) => { 
                                            setFormValues((preVal: any) => {
                                                return { ...preVal, org_id: e , client_id: "" , gateway : "" };
                                            });
                                            setFormValuesErr((preVal: any) => {
                                                return { ...preVal, org_id: "" };
                                            });
                                            setAllGateways([])
                                            fetchClients(e);
                                        }}
                                        notFoundContent={"Entered organization not found!"}
                                    />
                                    {formValuesErr?.org_id && (
                                        <p className="text-sm text-orange-500">
                                        The field is required
                                        </p>
                                    )}
                                </div>
                            </div>
                            <div className="flex gap-5 mt-2">
                                <div className="w-full">
                                    <label
                                        htmlFor="org_id"
                                        className={`ml-1.5 text-sm font-bold text-gray-900 dark:text-white`}
                                    >
                                        Client<span className="important">*</span>
                                    </label>
                                    <AntSelect
                                        showSearch={true}
                                        filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                        allowClear
                                        placeholder="Select Clients"
                                        optionFilterProp="children"
                                        className="h-[48px] w-full mt-[5px]"
                                        options={clients?.map((m: any) => {
                                        return {
                                            label: m?.name,
                                            value: m?.id,
                                        };
                                        })}
                                        value={formValues?.client_id || undefined}
                                        onChange={(e: any) => {
                                            setFormValues((preVal: any) => {
                                                return { ...preVal, client_id: e , gateway : "" };
                                            });
                                            setFormValuesErr((preVal: any) => {
                                                return { ...preVal, client_id: "" };
                                            });
                                            setAllGateways([])
                                            fetchGateways(e)
                                        }}
                                        notFoundContent={"Entered client not found!"}
                                    />
                                    {formValuesErr?.client_id && (
                                        <p className="text-sm text-orange-500">
                                        The field is required
                                        </p>
                                    )}
                                </div>
                            </div>
                            <div className="flex gap-5 mt-2">
                                <div className="w-full">
                                    <label
                                        htmlFor="org_id"
                                        className={`ml-1.5 text-sm font-bold text-gray-900 dark:text-white`}
                                    >
                                        Gateway<span className="important">*</span>
                                    </label>
                                    <AntSelect
                                        showSearch={true}
                                        filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                        allowClear
                                        placeholder="Select Gateway"
                                        optionFilterProp="children"
                                        className="h-[48px] w-full mt-[5px]"
                                        options={allGateways?.map((m: any) => {
                                        return {
                                            ...m,
                                            label: m?.name,
                                            value: m?.id,
                                        };
                                        })}
                                        value={formValues?.gateway || undefined}
                                        onChange={(e: any) => {
                                            setFormValues((preVal: any) => {
                                                return { ...preVal, gateway: e };
                                            });
                                            setFormValuesErr((preVal: any) => {
                                                return { ...preVal, gateway: "" };
                                            });
                                        }}
                                        onSelect={(value, option) => {
                                        }}
                                        notFoundContent={"Entered gateway not found!"}
                                    />
                                    {formValuesErr?.gateway && (
                                        <p className="text-sm text-orange-500">
                                        The field is required
                                        </p>
                                    )}
                                </div>
                            </div>
                            <div className="flex gap-5 mt-2">
                                <div className="w-full">
                                    <label
                                        htmlFor="org_id"
                                        className={`ml-1.5 text-sm font-bold text-gray-900 dark:text-white`}
                                    >
                                        Settlement Currency<span className="important">*</span>
                                    </label>
                                    <AntSelect
                                        showSearch={true}
                                        filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                        allowClear
                                        placeholder="Select Settlement Currency"
                                        optionFilterProp="children"
                                        className="h-[48px] w-full mt-[5px]"
                                        options={currencyCodes.map(
                                            (currencyCode) => {
                                                const currencyDetails =
                                                    getCurrencySymbol(currencyCode);
                                                return {
                                                    value: currencyCode,
                                                    label: `${currencyCode}: ${currencyDetails.title?.toUpperCase()}`,
                                                };
                                            }
                                        )}
                                        value={sourceCurrency || undefined}
                                        onChange={(e: any) => {
                                            setSourceCurrency(e)
                                        }}
                                        notFoundContent={"Entered gateway not found!"}
                                    />
                                    {formValuesErr?.gateway && (
                                        <p className="text-sm text-orange-500">
                                        The field is required
                                        </p>
                                    )}
                                </div>
                            </div>
                            <div className="flex gap-5 mt-3">
                                <div className="w-full ">
                                    <div className="flex">
                                        <div className="ml-2 flex items-center">
                                            <input
                                                type="radio"
                                                className="h-4 w-4"
                                                id="autoApprove"
                                                name="algo"
                                                value="regular"
                                                checked={formValues.batch_type == "regular"}
                                                // onChange={(e) => {
                                                //     setFormValues((preVal: any) => {
                                                //         return { ...preVal, batch_type: e.target.value};
                                                //     });
                                                //     setFormValuesErr((preVal: any) => {
                                                //         return { ...preVal, batch_type: "" };
                                                //     });
                                                // }}
                                                onChange={(e: any) => handleFieldChange("batch_type", e.target.value)}

                                            />
                                            <label
                                            htmlFor="autoApprove"
                                            className="mx-2 items-center"
                                            >
                                            Regular Batch
                                            </label>
                                        </div>
                                        <div className="ml-2 flex items-center">
                                            <input
                                                type="radio"
                                                className="h-4 w-4"
                                                id="requireApprove"
                                                name="algo"
                                                value="tokenize"
                                                checked={formValues.batch_type == "tokenize"}
                                                // onChange={(e) => {
                                                //     setFormValues((preVal: any) => {
                                                //         return { ...preVal, batch_type: e.target.value};
                                                //     });
                                                //     setFormValuesErr((preVal: any) => {
                                                //         return { ...preVal, batch_type: "" };
                                                //     });
                                                    
                                                // }}
                                                onChange={(e: any) => handleFieldChange("batch_type", e.target.value)}
                                            />
                                            <label
                                            htmlFor="requireApprove"
                                            className="mx-2 items-center"
                                            >
                                            Tokenize Batch
                                            </label>
                                        </div>
                                    </div>
                                    {formValuesErr?.batch_type && formValues.batch_type === "" && (
                                        <p className="text-sm mt-1 text-orange-500">
                                            The field is required
                                        </p>
                                    )}
                                </div>
                            </div>
                            <div className="flex gap-5 mt-3 mb-4">
                                <div className="w-full ">
                                    <div className="flex flex-col ">
                                        {/* <p className="mb-3 ml-1.5 text-sm font-bold text-gray-900">CSV File * <a href={Batch} download="SampleBatch.csv" className="ml-[5px]">Download Sample CSV</a></p> */}
                                        <p className="mb-3 ml-1.5 text-sm font-bold text-gray-900">
                                            CSV File * 
                                            {/* <a href={Batch} download="SampleBatch.csv" className="ml-[5px]">Download Sample CSV</a> */}
                                            {sampleBatchFile ? (
                                                <a
                                                    href={sampleBatchFile}
                                                    // download={smapleBatchName}
                                                    download={`${smapleBatchName}.csv`}
                                                    className="ml-[5px] text-blue-600 hover:underline"
                                                >
                                                    Download {smapleBatchName}
                                                </a>
                                                ) : (
                                                <></>
                                                )}
                                        </p>
                                        <FileDropzone label="Upload Batch CSV File" onFileSelect={setBatchFile} onRemoveFile={setRemoveFile} sampleBatchFile={sampleBatchFile} resetKey={resetKey}/>
                                    </div>
                                    {formValuesErr?.batch_file && (
                                        <p className="text-sm mt-1 text-orange-500">
                                        The field is required
                                        </p>
                                    )}
                                </div>
                            </div>
                            {isBalanceLoading ? (
                                <div className="flex gap-5 mt-3 mb-4">
                                    <DivLoader className="m-5 h-6 w-6 border-indigo-500" />
                                </div>
                            ) : displayData ? (
                                    <>
                                        <div className="space-y-4 mb-3">
                                            <div className="bg-white rounded-xl shadow p-4 border border-gray-200">
                                                <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-4">
                                                <div>
                                                    <h3 className="text-sm font-medium text-gray-500">Total Batch Amount</h3>
                                                    <p className="mt-1 text-2xl font-bold text-gray-800">
                                                    {displayData?.total_amount?.totalAmount?.toFixed(2)} {sourceCurrency}
                                                    </p>
                                                </div>
                                                <div className="text-xs text-gray-500 space-y-1">
                                                    <div>Percentage Fee: <span className="font-medium">{displayData?.total_amount?.totalPercentageFee?.toFixed(2)} {sourceCurrency}</span></div>
                                                    <div>Fixed Fee: <span className="font-medium">{displayData?.total_amount?.totalFixedFee?.toFixed(2)} {sourceCurrency}</span></div>
                                                    {/* <div>Total Fees: <span className="font-medium">{displayData?.total_amount?.totalFees?.toFixed(6)} {sourceCurrency}</span></div> */}
                                                </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            {/* <div className="bg-white rounded-xl shadow p-4 border border-gray-200">
                                            <h3 className="text-sm font-medium text-gray-500">{displayData?.gateway} Balance</h3>
                                            <p className="mt-1 text-2xl font-bold text-green-600">
                                                {parseFloat(displayData?.gateway_balance).toFixed(6)} {displayData?.currency}
                                            </p>
                                            </div> */}
                                            <div className="bg-white rounded-xl shadow p-4 border border-gray-200">
                                                <h3 className="text-sm font-medium text-gray-500">Total Fees:</h3>
                                                <p className="mt-1 text-2xl font-bold text-green-600">
                                                    {displayData?.total_amount?.totalFees?.toFixed(2)} {displayData?.currency}
                                                </p>
                                            </div>
                                            <div className="bg-white rounded-xl shadow p-4 border border-gray-200">
                                                <h3 className="text-sm font-medium text-gray-500">Client Treasury</h3>
                                                <p className="mt-1 text-2xl font-bold text-blue-600">
                                                    {parseFloat(displayData?.client_treasury).toFixed(2)} {sourceCurrency}
                                                </p>
                                            </div>
                                        </div>
                                        {lowBalanceError && (
                                            <div className="rounded-xl bg-red-100 shadow border text-red-700 px-4 py-3 mt-3 mb-2" role="alert">
                                                <p className="font-semibold">Something went wrong!</p>
                                                <p>{lowBalanceError}</p>
                                            </div>
                                        )}
                                    </>
                            ) : null}
                        </div>
                    </ModalBody>
                    <ModalFooter className="mt-[10px]">
                        <div className="mt-5 flex gap-2 px-[30px] pb-[30px]">
                            <button
                            onClick={handleClose}
                            className="linear rounded-xl bg-indigo-600 px-5 py-2 text-white font-medium  outline-none transition duration-200 hover:bg-indigo-500 active:bg-indigo-500 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30"
                            >
                                Close
                            </button>
                            <button
                                onClick={handleSubmit}
                                disabled={isLoading || addDisabled}
                                className="linear update rounded-xl bg-indigo-600 px-5 py-2 text-base font-medium text-white outline-none transition duration-200  dark:bg-indigo-400/10 dark:text-white dark:hover:bg-indigo-300/10 dark:active:bg-indigo-200/10"
                            >
                                {isLoading ? (
                                    <DivLoader className="h-6 w-6 border-white" />
                                ) : (
                                <>{"Add Batch"}</>
                                )}
                            </button>
                        </div>
                    </ModalFooter>
                </Card>
            </Modal>
        </>
    )
}

export default AddBatchFile;